// @flow
import { createSelector } from "reselect"
import { Map } from "immutable"

import type Place from "../../records/Place"

type State = {
  +places: Map<string, Place>,
}

export const placesSelector = (state: State) => state.places.get("places")

export const placesUrlsMap: $FlowFixMe = createSelector(
  [placesSelector],
  places => places.reduce((acc, place) => acc.set(place.slug, place), Map({})),
)

export const placesIdsMap: $FlowFixMe = createSelector(
  [placesSelector],
  places => places.reduce((acc, place) => acc.set(place.get("id"), place), Map({})),
)

// useful for backward compatibility in urls (slug or id)
export const placesUrlsIdsMap: $FlowFixMe = createSelector(
  [placesUrlsMap, placesIdsMap],
  (placesUrls, placesIds) => placesIds.merge(placesUrls),
)
